import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Composant qui scroll automatiquement vers le haut de la page
 * lors de chaque changement de route, ou vers l'ancre si présente
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Si il y a une ancre dans l'URL, scroll vers l'élément correspondant
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        // Petit délai pour s'assurer que le DOM est prêt
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
        return;
      }
    }
    
    // Sinon, scroll vers le haut
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    
    // Backup avec un petit délai pour s'assurer que ça fonctionne
    const timeout = setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 0);

    return () => clearTimeout(timeout);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;

